import { api } from '../../services/authService';

const BASE = '/api/v2/data-dictionary';

export const PAGE_SIZE = 50;

/** Build /search query params from browse scope + filters. */
export function buildSearchParams({ scope, filters, sortBy, sortOrder, offset, limit = PAGE_SIZE }) {
  const params = { offset, limit, sort_by: sortBy, sort_order: sortOrder };
  if (scope?.type === 'folder' && Array.isArray(scope.path) && scope.path.length) {
    params.folder_path = scope.path.join(',');
  } else if (scope?.type === 'nofolder') {
    params.folder_null = true;
  } else if (scope?.type === 'table') {
    if (scope.schema) params.schema = scope.schema;
    if (scope.table) params.table_name = scope.table;
  } else if (scope?.type === 'schema' && scope.schema) {
    params.schema = scope.schema;
  }
  if (filters?.q?.trim()) params.q = filters.q.trim();
  if (filters?.visible === true || filters?.visible === false) params.visible = filters.visible;
  if (filters?.complete === true || filters?.complete === false) params.complete = filters.complete;
  if (filters?.tag) params.tag = filters.tag;
  if (filters?.missing) params.missing = filters.missing;
  return params;
}

export const dataDictionaryApi = {
  search: (params, config = {}) => api.get(`${BASE}/search`, { params, ...config }).then((r) => r.data),
  updateRow: (row, changes) =>
    api
      .patch(`${BASE}/row`, {
        schema: row.schema ?? '',
        table_name: row.table_name ?? '',
        column_name: row.column_name ?? '',
        ...changes,
      })
      .then((r) => r.data),
  bulkUpdate: (rows, changes) =>
    api
      .post(`${BASE}/bulk`, {
        rows: rows.map((row) => ({
          schema: row.schema ?? '',
          table_name: row.table_name ?? '',
          column_name: row.column_name ?? '',
        })),
        ...changes,
      })
      .then((r) => r.data),
  stats: () => api.get(`${BASE}/stats`).then((r) => r.data),
  folders: () => api.get(`${BASE}/folders`).then((r) => r.data),
  tags: () => api.get(`${BASE}/tags`).then((r) => r.data),
  publishStatus: ({ includePending = true } = {}) =>
    api.get(`${BASE}/publish-status`, { params: { include_pending: includePending } }).then((r) => r.data),
  pendingChanges: (limit = 100) =>
    api.get(`${BASE}/pending-changes`, { params: { limit } }).then((r) => r.data),
  apply: () => api.post(`${BASE}/apply`).then((r) => r.data),
};

export default dataDictionaryApi;
